<div class="envio-container">
  <h3 class="title">Solicitud de Reembolso</h3>
  
  <!-- Checkbox Gestante -->
  <nz-spin [nzSpinning]="loading">
  <div class="border-items" *ngIf="gestantes">
    <div class="checkbox-container">
      <span class="checkbox-text">* ¿ Las facturas corresponden a gastos de un bebé gestante ?</span>
      <label class="checkbox-label">
        <input 
          type="checkbox" 
          [(ngModel)]="esGestante"
          class="checkbox-input">
        <span class="checkmark"></span>
      </label>
    </div>
  </div>

  <!-- Sección de Pares de Archivos -->
   <h3 class="header-title">Archivos</h3>
  <div class="pares-section">
    <div class="section-header">
      <button 
        type="button" 
        class="btn-agregar"
        (click)="agregarPar()"
        [disabled]="paresDatos.length >= 10">
        + Agregar Archivos
      </button>

    <button 
      type="button" 
      class="btn-agregar"
      (click)="enviarSolicitud()"
      [disabled]="!isFormValido || isUploading">
      {{isUploading ? 'Enviando...' : 'Aceptar'}}
    </button>
  <!-- </div> -->
    </div>
    <!-- Lista de Pares -->
    <div class="pares-lista" *ngIf="paresDatos.length > 0">
      <div 
        *ngFor="let par of paresDatos; let i = index" 
        class="par-item"
        [class.completo]="par.completo">
        
        <div class="par-header">
          <!-- <span class="par-numero">Par {{i + 1}}</span> -->
          <button 
            type="button" 
            class="btn-eliminar"
            (click)="eliminarPar(i)"
            *ngIf="paresDatos.length > 1">
            ✕
          </button>
        </div>

        <div class="archivos-container">
          <!-- Archivo PDF -->
          <div class="archivo-group">
            <!-- <label class="archivo-label">PDF *</label> -->
            <div class="file-input-wrapper">
              <input 
                type="file" 
                #pdfInput
                accept=".pdf,application/pdf"
                (change)="onPdfSeleccionado($event, i)"
                class="file-input"
                [id]="'pdf-' + par.id">
              <button 
                type="button" 
                class="btn-seleccionar"
                [class.selected]="par.pdf"
                (click)="pdfInput.click()">
                {{par.pdf ? (par.pdf.name.slice(0, longitud) + "...") : 'Seleccionar PDF'}}
              </button>
            </div>
            <div class="file-info" *ngIf="par.pdf">
              Tamaño: {{formatFileSize(par.pdf.size)}}
            </div>
          </div>

          <!-- Archivo XML -->
          <div class="archivo-group">
            <!-- <label class="archivo-label">Archivo XML *</label> -->
            <div class="file-input-wrapper">
              <input 
                type="file" 
                #xmlInput
                accept=".xml,application/xml,text/xml"
                (change)="onXmlSeleccionado($event, i)"
                class="file-input"
                [id]="'xml-' + par.id">
              <button 
                type="button" 
                class="btn-seleccionar"
                [class.selected]="par.xml"
                (click)="xmlInput.click()">
                {{par.xml ? (par.xml.name.slice(0, longitud) + "...") : 'Seleccionar XML'}}
              </button>
            </div>
            <div class="file-info" *ngIf="par.xml">
              Tamaño: {{formatFileSize(par.xml.size)}}
            </div>
          </div>
        </div>

        <!-- Estado del Par -->
        <div class="par-estado">
          <span class="estado-badge" [class.completo]="par.completo">
            {{par.completo ? '✓ Completo' : '⚠ Incompleto'}}
          </span>
        </div>
      </div>
    </div>

    <!-- Estado vacío -->
    <div class="estado-vacio" *ngIf="paresDatos.length === 0">
      <p>No hay pares de archivos. Haga clic en "Agregar par de archivos" para comenzar.</p>
    </div>
  </div>

  <!-- Resumen -->
  <!-- <div class="resumen-section" *ngIf="paresDatos.length > 0">
    <div class="resumen-stats">
      <span class="stat-item">{{paresCompletos}} de {{paresDatos.length}} pares completos</span>
      <span class="stat-item">{{paresDatos.length * 2}} archivos en total</span>
    </div>
  </div> -->

  <!-- Errores -->
  <div class="errores-section" *ngIf="errores.length > 0">
    <div class="error-item" *ngFor="let error of errores">
      ⚠️ {{error}}
    </div>
  </div>

  <!-- Progreso de carga -->
  <!-- <div class="progreso-section" *ngIf="isUploading">
    <div class="progreso-bar">
      <div 
        class="progreso-fill" 
        [style.width.%]="uploadProgress.percentage">
      </div>
    </div>
    <div class="progreso-text">
      Enviando... {{uploadProgress.percentage}}%
    </div>
  </div> -->

  <!-- Mensaje de éxito -->
  <!-- <div class="exito-section" *ngIf="mensajeExito">
    <div class="mensaje-exito">
      ✅ {{mensajeExito}}
    </div>
  </div> -->

  <!-- Botones de Acción -->
  </nz-spin>
</div>
